/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateRequired = (component, value) => {
    watchBoolean(component, '_required', value);
};

export { validateRequired as v };
//# sourceMappingURL=required-CGf-IRxL.js.map

//# sourceMappingURL=required-CGf-IRxL.js.map